import { createFileRoute, useSearch } from '@tanstack/react-router';
import { DocumentForm } from '@/pages/documents/form';
import { DebtForm } from '@/pages/debts/form';
import { PROTECTED, ADMINISTRATION } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${ADMINISTRATION}`;

export const Route = createFileRoute(
  '/protected/_layout/administration/_layout/new'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: NewAdministrationModal,
});

function NewAdministrationModal() {
  const search = useSearch({ strict: false }) as { subTab?: string };
  const subTab = search.subTab ?? 'payroll';
  if (subTab === 'debts') {
    return <DebtForm returnUrl={RETURN_URL} />;
  }
  return <DocumentForm subTab={subTab} returnUrl={RETURN_URL} />;
}
